import React from "react";
import AnimatedCounter from "./AnimatedCounter";
import "./Home.css"
function HomeAboutSection() {
  return (
    <div className="about4-section-area sp1">
      <div className="container">
        <div className="row g-3 align-items-center">
          <div className="col-lg-6">
            <div className="about-images-area">
              <div className="img1 image-anime reveal">
                <img
                  src="assets/img/all-images/about/about-img9.png"
                  alt=""
                />
              </div>
              <div className="img2">
                <img
                  src="assets/img/elements/elements16.webp"
                  alt=""
                  className="elements18 keyframe3"
                />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
  <div className="about4-heading heading4">
    <h5
      className="vl-section-subtitle"
      data-aos="fade-left"
      data-aos-duration="800"
    >
      JEEVANDAAN Hospital<span> | </span> About Us
    </h5>

    <div className="space24" />

    <h2
      className="vl-section-title text-anime-style-3"
      data-aos="fade-left"
      data-aos-duration="1000"
      data-aos-delay="150"
    >
      Your Health & Happiness Are Our Top Priorities.
    </h2>

    <div className="space24" />

    <p
      data-aos="fade-left"
      data-aos-duration="900"
      data-aos-delay="300"
    >
      At JEEVANDAAN Hospital, we go beyond treatment to deliver
      compassionate, patient-first healthcare with experienced
      doctors and modern facilities.
    </p>

    <div className="row g-3">
      <div
        className="col-lg-6 col-6"
        data-aos="zoom-in"
        data-aos-delay="400"
      >
        <div className="counter-boxarea">
          <AnimatedCounter end={500} suffix="+" />
          <div className="space16" />
          <p>Patients Treated Every Month</p>
        </div>
      </div>

      <div
        className="col-lg-6 col-6"
        data-aos="zoom-in"
        data-aos-delay="500"
      >
        <div className="counter-boxarea">
          <AnimatedCounter end={95} suffix="%" />
          <div className="space16" />
          <p>Patient Satisfaction Rate</p>
        </div>
      </div>

      <div
        className="col-lg-6 col-6"
        data-aos="zoom-in"
        data-aos-delay="600"
      >
        <div className="counter-boxarea">
          <AnimatedCounter end={10} suffix="+" />
          <div className="space16" />
          <p>Years of Trusted Healthcare</p>
        </div>
      </div>

      <div
        className="col-lg-6 col-6"
        data-aos="zoom-in"
        data-aos-delay="700"
      >
        <div className="counter-boxarea">
          <AnimatedCounter end={24} suffix="/7" />
          <div className="space16" />
          <p>Emergency & Critical Care</p>
        </div>
      </div>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
}

export default HomeAboutSection;
